export default {
  main: '#7D0118',
  secondary: '#005D68',
  contrastingColor: '#ffffff',
  priceColor: '#7D0118',
  entryBackground: '#7D0118',
  menuBackgroundColor: '#001857',
  menuTextColor: '#ffffff',
};
